import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Entity = {
  type: string;
  id: number;
};

export type EntityRecordState = {
  open: boolean;
  entity: Entity | null;
};

const initialState: EntityRecordState = {
  open: false,
  entity: null,
};

const entityRecordSlice = createSlice({
  name: 'entityRecord',
  initialState,
  reducers: {
    showEntityRecord: (state, action: PayloadAction<Entity>) => {
      state.open = true;
      state.entity = action.payload;
    },
    hideEntityRecord: (state) => {
      state.open = false;
      state.entity = null;
    },
  },
});

export const { showEntityRecord, hideEntityRecord } = entityRecordSlice.actions;
export default entityRecordSlice.reducer;
